import React from 'react';
import { Button } from 'devextreme-react/button';

const CustomButton = ({text, icon, onClick, type="success"}) => {
    return (        
            <Button
                className ='btn-header'               
                type={type}
                text={text}
                icon={icon}
                stylingMode="outlined"
                onClick={onClick}
            />       
    );
}



export default CustomButton;
